import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './components/Home';
import ContactUs from './components/ContactUs';
import Blog from './components/Blog';
import CabTours from './components/CabTours';
import TourPlanningTool from './components/tour-planner/TourPlanningTool';
import BurgerMenu from './components/BurgerMenu';
import './Styles.css';
import './App.css';

function App() {
  return (

      <Router>
         <BurgerMenu />
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/cab-tours" element={<CabTours />} />
                <Route path="/tour-planning-tool" element={<TourPlanningTool />} />
                <Route path="/blog" element={<Blog />} />
                <Route path="/contact" element={<ContactUs />} />
            </Routes>
      </Router>
  );
}

export default App;
